var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_472",
    x: 0,
    y: 0,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3209",
    "data-name": "Group 3209",
    transform: "translate(-206 -765)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_472-2",
    "data-name": "Ellipse 472",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(206 765)",
    fill: "#feed00"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 206, 765)",
    filter: "url(#Ellipse_472)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_472-3",
    "data-name": "Ellipse 472",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-plus",
    "data-name": "Icon feather-plus",
    transform: "translate(217.98 768.125) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85747",
    "data-name": "Path 85747",
    d: "M.732,8.855A.732.732,0,0,1,0,8.124V.732a.732.732,0,0,1,1.463,0V8.124A.732.732,0,0,1,.732,8.855Z",
    transform: "translate(3.696 0)",
    fill: "#0094d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85748",
    "data-name": "Path 85748",
    d: "M8.124,1.463H.732A.732.732,0,0,1,.732,0H8.124a.732.732,0,0,1,0,1.463Z",
    transform: "translate(0 3.696)",
    fill: "#0094d9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.32c7aed311dca64737d7e961aaf333f3.svg";
export { ForwardRef as ReactComponent };